import useCreateMarkup from 'components/Dashboard/hooks/useCreateMarkup';
import time from 'utils/time';
import getInteractionDisplayType from 'components/Dashboard/Influence/CrmInteractions/getInteractionDisplayType';
import EmailCampaignReportBlocks from 'components/Dashboard/Influence/CrmInteractions/EmailCampaignReport/EmailCampaignReportBlocks';

const CrmInteractionNewContent = (props) => {
  const { currentNew, reportWidget, emailBlocks } = props;
  const {
    title,
    interactionType,
    sourceCrmEmailId,
    dateTime,
    addedByUserFullName,
    description,
    htmlBody,
    crmContactNames,
    emailCampaignData,
  } = currentNew ?? {};
  const interactionDisplayType = getInteractionDisplayType({ interactionType, sourceCrmEmailId });
  const senderEmailAddress = emailCampaignData?.crmEmail?.senderEmailAddress;
  const showEmailCampaignBlocks = sourceCrmEmailId && emailBlocks && Object.values(emailBlocks).some(Boolean);

  const { createMarkup } = useCreateMarkup();

  return (
    <>
      <div
        className={`section-title pb-2 interaction-content-title ${
          reportWidget ? 'content-title-in-widget' : 'content-title-with-summary'
        } content-border-title`}
      >
        <h3 className='main-title news-title bg-white content-item-title'>{title}</h3>
        <p className='heading-date mb-0'>
          {interactionDisplayType && (
            <>
              <span className='date'>{interactionDisplayType}</span>
              <span className='dot'></span>
            </>
          )}
          {senderEmailAddress && (
            <>
              <span className='date'>From {senderEmailAddress}</span>
              <span className='dot'></span>
            </>
          )}
          {addedByUserFullName && (
            <>
              <span className='date'>{addedByUserFullName}</span>
              <span className='dot'></span>
            </>
          )}
          {crmContactNames?.length > 0 && (
            <>
              <span className='date'>
                {crmContactNames.length} stakeholder{crmContactNames.length > 1 ? 's' : ''}
              </span>
              <span className='dot'></span>
            </>
          )}
          {dateTime && <span className='date'>{time(dateTime).formatLongDate()}</span>}
        </p>
      </div>
      <div className='pb-3 pb-lg-4 px-3 px-lg-4 specific-content-container mt-2'>
        {showEmailCampaignBlocks ? (
          <EmailCampaignReportBlocks emailBlocks={emailBlocks} emailCampaignData={emailCampaignData} />
        ) : (
          (htmlBody || description) && (
            <div
              className='news-content-in parliamentary-content-in context'
              dangerouslySetInnerHTML={createMarkup(htmlBody || description)}
            />
          )
        )}
      </div>
    </>
  );
};

export default CrmInteractionNewContent;
